'use strict'

import axios from 'axios'

export default axios.create({
  // baseURL: 'http://localhost:50875/api/'
  baseURL: process.env.API
  /* headers: {
    'Authorization': `Bearer ${localStorage.getItem('user-token')}`
  } */
})



// WEBPACK FOOTER //
// ./src/axios.js